<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-container>
          <input
            id="pessoa-id"
            type="hidden"
            v-model="pessoa.id"
          />
          <input
            id="pessoa-uuid"
            type="hidden"
            v-model="pessoa.uuid"
          />
          <input
            id="pessoa-esic"
            type="hidden"
            v-model="pessoa.esic"
          />
          <v-row>
            <v-col
              cols="12"
              lg="3"
              md="2"
            >
              <v-text-field
                v-model="codigo"
                label="Código"
                outlined
                dense
              >
                <v-icon
                  slot="append"
                  color="success"
                  large
                  @click="loadDialog"
                >
                  mdi-magnify
                </v-icon>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="2"
              v-if="pessoa.id"
            >
              <v-checkbox
                v-model="pessoa.inativar"
                label="Inativar usuário ?"
                color="success"
                v-show="mode === 'save'"
              >
              </v-checkbox>
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-checkbox
                v-model="pessoa.esic"
                label="Usuário do eSic ?"
                color="success"
                hide-details
                v-show="mode === 'save'"
              >
              </v-checkbox>
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-checkbox
                v-model="pessoa.fornecedor"
                label="Fornecedor ?"
                color="success"
                hide-details
                v-show="mode === 'save'"
              >
              </v-checkbox>
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="codigo"
            >
              <v-checkbox
                v-model="pessoa.cgc_updated"
                label="atualizar cgc/cpf ?"
                color="success"
                hide-details
                @click="loadInpCgc()"
                v-show="mode === 'save'"
              >
              </v-checkbox>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              cols="12"
              md="3"
              v-if="codigo"
            >
              <v-btn
                color="default"
                @click.prevent="altPass"
              >
                <v-icon
                  left
                  color="green"
                >
                  mdi-account-key
                </v-icon>
                Redefinir senha
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="px-1">
            <v-col
              cols="12"
              lg="4"
              md="4"
              sm="12"
            >
              <v-autocomplete
                v-model="pessoa.tipo_pessoa"
                :items="tPessoa"
                label="Tipo de pessoa"
                required
                outlined
                dense
                @change="loadFuncaoPessoa()"
              ></v-autocomplete>
            </v-col>
            <input
              id="pessoa-cgc"
              type="hidden"
              v-model="pessoa.cgc"
            />
            <v-col
              cols="12"
              lg="4"
              md="4"
              sm="12"
              v-if="inputcpf === true"
            >
              <div v-if="verCpf === true">
                <v-text-field
                  v-model="pessoa.cgc_txt"
                  clearable
                  v-mask="cpf"
                  label="CPF"
                  :error="error"
                  :error-messages="message"
                  outlined
                  dense
                  required
                  @blur="formataCpf()"
                  @focus="limpaValidacao()"
                >
                </v-text-field>
              </div>
              <div v-if="verCnpj === true">
                <v-text-field
                  v-model="pessoa.cgc_txt"
                  clearable
                  v-mask="cnpj"
                  label="CNPJ"
                  :error="error"
                  :error-messages="message"
                  outlined
                  dense
                  required
                  @blur="formataCnpj()"
                  @focus="limpaValidacao()"
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              lg="4"
              md="4"
              sm="12"
              v-if="inputcpf === false"
            >
              <v-card-text class="py-0 mt-0">CPF/ CNPJ<h4>{{ cgccpf }}</h4>
              </v-card-text>
            </v-col>
            <v-col
              cols="12"
              lg="4"
              md="4"
              sm="12"
              v-if="tipo === 'pfisica'"
            >
              <v-text-field
                v-model="pessoa.rg"
                label="Rg"
                clearable
                outlined
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            class="px-1"
            v-if="pessoa.cgc_updated"
          >
            <v-col
              cols="12"
              lg="12"
              md="12"
              sm="12"
            >
              <v-text-field
                v-model="pessoa.cgc_updated_motivo"
                type="text"
                label="Motivo da atuteração no cpf ou cnpj"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-card>
            <v-tabs
              background-color="primary"
              dark
              v-model="tabs"
            >
              <v-tab>
                <v-icon
                  small
                  class="mx-1"
                >
                  mdi-folder-information
                </v-icon>
                Principal
              </v-tab>
              <v-tab @click="loadEstados">
                <v-icon
                  small
                  class="mx-1"
                >
                  mdi-card-account-mail
                </v-icon>
                Inf. de contato
              </v-tab>
              <v-tab
                @click="loadTbelas"
                :disabled="tipo === 'pjuridica'"
              >
                <v-icon
                  small
                  class="mx-1"
                >
                  mdi-account-box
                </v-icon>
                Inf. pessoais
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <v-card
                  flat
                  class="mt-2 pt-2"
                >
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="7"
                      md="12"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.nome"
                        :rules="[rules.required, rules.name]"
                        type="text"
                        :label="`${nameLabel}`"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="5"
                      md="12"
                      sm="12"
                      v-if="tipo === 'pjuridica'"
                    >
                      <v-text-field
                        v-model="pessoa.fantasia"
                        type="text"
                        label="Nome fantasia"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="7"
                      md="6"
                      sm="12"
                      v-if="tipo === 'pjuridica'"
                    >
                      <v-text-field
                        v-model="pessoa.responsavel"
                        :rules="[rules.required]"
                        type="text"
                        label="Nome do responsável *"
                        outlined
                        dense
                        hint="Campo obrigatório"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="5"
                      md="6"
                      sm="12"
                      v-if="tipo === 'pjuridica'"
                    >
                      <v-text-field
                        v-model="pessoa.cargo_responsavel"
                        type="text"
                        label="Cargo :"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                      v-if="tipo === 'pjuridica'"
                    >
                      <v-autocomplete
                        v-model="pessoa.tipo_instituicao"
                        :items="instituicao"
                        label="Tipo de instituição"
                        required
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                      v-if="tipo === 'pjuridica'"
                    >
                      <v-autocomplete
                        v-model="pessoa.area_atuacao"
                        :items="atuacao"
                        label="Àrea de atuação"
                        required
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        clearable
                        v-model="pessoa.email"
                        type="email"
                        required
                        label="E-mail"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        clearable
                        v-model="pessoa.email_confirma"
                        type="email"
                        required
                        label="Confirmação do e-mail"
                        outlined
                        dense
                      >
                        >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="mt-2 pt-2"
                >
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="3"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.fone"
                        autocomplete="off"
                        v-mask="fone"
                        label="Telefone"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="3"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.celular"
                        autocomplete="off"
                        v-mask="cel"
                        label="Celular:"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="3"
                      md="3"
                      sm="12"
                    >
                      <v-autocomplete
                        clearable
                        v-model="pessoa.uf"
                        :items="estados"
                        label="Estado de origem"
                        outlined
                        dense
                        @change="loadCidades()"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      md="7"
                      sm="12"
                    >
                      <v-autocomplete
                        v-if="verCidade === false"
                        clearable
                        v-model="pessoa.cidade"
                        :items="cidades"
                        label="Cidade de origem"
                        outlined
                        dense
                        :disabled="!pessoa.uf"
                      >
                      </v-autocomplete>
                      <v-text-field
                        v-if="verCidade === true"
                        v-model="pessoa.cidade"
                        label="Cidade de origem"
                        outlined
                        dense
                        @click="verSelect"
                        :disabled="!pessoa.uf"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="3"
                      md="2"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.cep"
                        v-mask="cep"
                        label="Número"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="10"
                      md="8"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.rua"
                        type="text"
                        label="Logradouro"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="2"
                      md="4"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.numero"
                        type="text"
                        label="Cep"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.bairro"
                        type="text"
                        label="Bairro"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.complemento"
                        type="text"
                        label="Complemento"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="mt-2 pt-2"
                >
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="3"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="pessoa.data_nascimento"
                        type="date"
                        label="Data de Nascimento :"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="4"
                      md="6"
                      sm="12"
                    >
                      <v-autocomplete
                        v-model="pessoa.genero"
                        :items="genero"
                        label="Gênero"
                        required
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="4"
                      md="6"
                      sm="12"
                    >
                      <v-autocomplete
                        v-model="pessoa.raca"
                        :items="raca"
                        label="Raça/cor"
                        required
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="5"
                      md="6"
                      sm="12"
                    >
                      <v-autocomplete
                        v-model="pessoa.escolaridade"
                        :items="instrucao"
                        label="Escolaridade"
                        required
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-autocomplete
                        v-model="pessoa.profissao"
                        :items="profissao"
                        label="Profissão"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-container>
        <small>* Campos indicados são obrigatórios</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          dark
          to="/administracao"
          v-if="!btnsair"
        >
          <v-icon
            left
            class="mr-3"
          >mdi-close</v-icon>
          Sair
        </v-btn>
        <v-btn
          color="primary"
          dark
          @click="reset"
        >
          <v-icon
            left
            class="mr-3"
          >mdi-brush</v-icon>
          Limpar
        </v-btn>
        <v-btn
          color="primary"
          @click="Save"
        >
          <v-icon
            left
            class="mr-3"
          >mdi-check</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar pessoas cadastradas
            </v-toolbar>
            <v-card-title>
              <v-card-title>
                Pesquisar
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Filtrar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filtro"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  @click="loadPessoaFilter(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  class="mr-2"
                  @click="loadPessoaFilter(item, 'remove')"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-card>
    <v-card class="px-5 borda-vm">
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="editPass"
            transition="dialog-top-transition"
            max-width="470"
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Redefinição de senha
                </v-toolbar>
                <div class="form-pass mx-auto mt-1">
                  <v-form>
                    <v-row
                      justify="space-around"
                      class="px-6 mx-6"
                    >
                      <v-col cols="12">
                        <v-text-field
                          class="py-1 text-field"
                          v-model="pass.password"
                          label="Nova senha"
                          type="password"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          class="py-1 text-field"
                          v-model="pass.confirmPassword"
                          label="Confime a senha"
                          type="password"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end py-6">
                  <v-btn
                    color="success"
                    class="mr-4"
                    @click.prevent="updatePass()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false, loadClose()"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { uuid } from 'vue-uuid'
import { mapState } from 'vuex'
const { cpf, cnpj } = require('cpf-cnpj-validator')
export default {
  name: 'Pessoas',
  props: ['btnsair'],
  components: {},
  computed: mapState(['user']),
  data: () => ({
    tabs: false,
    dialog: false,
    editPass: false,
    verCidade: false,
    search: '',
    uuid: '',
    verCpf: false,
    verCnpj: false,
    codigo: '',
    mode: 'save',
    tipo: 'pfisica',
    res: '',
    vLabel: '',
    dsLabel: '',
    nameLabel: '',
    color: 'null',
    error: false,
    message: '',
    cpf: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    fone: '(##)####-####',
    cel: '(##)#####-####',
    cep: '##.###-###',
    cgccpf: '',
    inputcpf: true,
    pessoa: {},
    pass: {},
    tPessoa: [],
    selected: 1,
    raca: [],
    instrucao: [],
    instituicao: [],
    atuacao: [],
    profissao: [],
    filtro: [],
    estados: [],
    cidades: [],
    show1: false,
    show2: true,
    password: 'Password',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'Cpf / Cgc', value: 'cgc_txt' },
      { text: 'Rg', value: 'rg' },
      { text: 'Nis', value: 'nis' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    genero: [
      { value: 'M', text: 'Masculino' },
      { value: 'F', text: 'Feminino' },
      { value: 'O', text: 'Outro' }
    ],
    rules: {
      required: value => !!value || 'Este campo é obrigatório',
      name: value => (value && value.length >= 4) || 'O nome ou razão social deve conter ao memos 4 caracteres!',
      min: value => (value && value.length >= 6) || 'A senha deve conter pelo menos 6 caracteres',
      emailMatch: () => (`A cofirmação é diferente!`),
      mailValid: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'O e-mail é invalido.'
      }
    },
    confirmPasswordRules: [
      (value) => !!value || 'Confirme a senha!'
    ],
    confirmEmailRules: [
      (value) => !!value || 'Confirme o e-mail!'
    ]
  }),
  methods: {
    Save () {
      const method = this.pessoa.id ? 'put' : 'post'
      const id = this.pessoa.id ? `/${this.pessoa.id}` : ''
      axios[method](`${baseApiUrl}/pessoas${id}`, this.pessoa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    savepes () {
      this.save()
    },
    update () {
      this.save()
    },
    updatePass () {
      const id = this.pessoa.uuid
      axios.put(`${baseApiUrl}/up-password-a4d8-e9c580/${id}`, this.pass)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.editPass = false
        })
        .catch(showError)
    },
    reset () {
      this.pessoa = {}
      this.codigo = ''
      this.cgccpf = ''
      this.inputcpf = true
      this.error = false
      this.pessoa.tipo_pessoa = 1
      this.pessoa.uuid = uuid.v1()
    },
    formataCpf () {
      const cpff = this.pessoa.cgc_txt
      const ccpf = cpf.isValid(cpff)
      const number = cpf.strip(cpff)
      if (ccpf === true) {
        this.pessoa.cgc = number
        this.error = false
        // this.btnSave = true
      } else {
        this.error = true
        this.message = `O CPf informado é inválido!`
      }
    },
    formataCnpj () {
      const cnpjj = this.pessoa.cgc_txt
      const ccnpj = cnpj.isValid(cnpjj)
      const number = cnpj.strip(cnpjj)
      if (ccnpj === true) {
        this.pessoa.cgc = number
        this.error = false
        // this.btnSave = true
      } else {
        this.error = true
        this.message = `O CNPJ informado é inválido!`
      }
    },
    loadOrgao () {
      const id = this.orgao.id
      const url = `${baseApiUrl}/sic-unidades-por-id/${id}`
      axios.get(url).then(res => {
        this.secretaria = res.data
      })
    },
    loadOrgaos () {
      const url = `${baseApiUrl}/sic-responsavel-list`
      axios.get(url).then(res => {
        this.orgaos = res.data.map(orgaos => {
          return {
            value: orgaos.id,
            text: orgaos.orgao
          }
        })
      })
    },
    loadInstrucao () {
      const url = `${baseApiUrl}/lista-escolaridade`
      axios.get(url).then(res => {
        this.instrucao = res.data.map(instrucao => {
          return {
            value: instrucao.id,
            text: `${instrucao.id} - ${instrucao.escolaridade}`
          }
        })
      })
    },
    loadRaca () {
      const url = `${baseApiUrl}/lista-raca-pessoa`
      axios.get(url).then(res => {
        this.raca = res.data.map(raca => {
          return {
            value: raca.id,
            text: raca.raca
          }
        })
      })
    },
    loadProfissao () {
      const url = `${baseApiUrl}/lista-profissao`
      axios.get(url).then(res => {
        this.profissao = res.data.map(profissao => {
          return {
            value: profissao.id,
            text: profissao.profissao
          }
        })
      })
    },
    loadPessoa () {
      const url = `${baseApiUrl}/lista-tipo-de-pessoa`
      axios.get(url).then(res => {
        this.tPessoa = res.data.map(tPessoa => {
          return {
            value: tPessoa.id,
            text: `${tPessoa.id} - ${tPessoa.tipo}`
          }
        })
      })
    },
    loadInstituicao () {
      const url = `${baseApiUrl}/lista-tipo-de-instituicao`
      axios.get(url).then(res => {
        this.instituicao = res.data.map(instituicao => {
          return {
            value: instituicao.id,
            text: instituicao.instituicao
          }
        })
      })
    },
    loadAtuacao () {
      const url = `${baseApiUrl}/lista-area-de-atuacao`
      axios.get(url).then(res => {
        this.atuacao = res.data.map(atuacao => {
          return {
            value: atuacao.id,
            text: atuacao.atuacao
          }
        })
      })
    },
    loadEstados () {
      const url = `${baseApiUrl}/estados`
      axios.get(url).then(res => {
        this.estados = res.data.map(estados => {
          return {
            value: estados.sigla,
            text: estados.nome
          }
        })
      })
      this.verCidade = true
    },
    loadCidades () {
      const uf = this.pessoa.uf
      const url = `${baseApiUrl}/estados/${uf}`
      axios.get(url).then(res => {
        this.cidades = res.data
      })
      this.verCidade = false
    },
    confirmEmail () {
      const em = this.pessoa.email
      const conf = this.pessoa.email_confirma
      if (em === conf) {
        this.error = false
      } else {
        this.error = true
        this.message = `A confirmação do e-mail não confere!`
      }
    },
    confirmSenha () {
      const pas = this.pessoa.password
      const conf = this.pessoa.confirmPassword
      if (pas === conf) {
        this.error = false
      } else {
        this.error = true
        this.message = `A confirmação da senha não confere!`
      }
    },
    limpaValidacao () {
      this.error = false
      this.message = ''
    },
    loadFiltro () {
      const url = `${baseApiUrl}/filtro-pessoas`
      axios.get(url).then(res => {
        this.filtro = res.data
      })
    },
    loadPessoaFilter (filtro, mode = 'save') {
      this.codigo = filtro.id
      const id = filtro.uuid
      this.mode = mode
      const url = `${baseApiUrl}/pessoas/${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.dialog = false
        const id = this.pessoa.id
        this.loaUpCgc(id)
      })
    },
    loaUpCgc (id) {
      if (id != null) {
        this.cgccpf = this.pessoa.cgc_txt
        this.inputcpf = false
      }
    },
    loadInpCgc () {
      const campo = this.pessoa.cgc_updated
      if (campo === true) {
        this.inputcpf = true
      } else {
        this.inputcpf = false
      }
      const pessoa = this.pessoa.tipo_pessoa
      if (pessoa === 1) {
        this.verCpf = true
        this.verCnpj = false
      } else {
        this.verCpf = false
        this.verCnpj = true
      }
    },
    passwordConfirmationRule () {
      return () =>
        this.pessoa.password === this.pessoa.confirmPassword || 'A confirmação da senha é inválida!'
    },
    emailConfirmationRule () {
      return () =>
        this.pessoa.email === this.pessoa.email_confirma || 'A confirmação do e-mail é inválida!'
    },
    altPass () {
      this.editPass = true
    },
    verSelect () {
      this.verCidade = false
      this.loadCidades()
    },
    loadDialog () {
      this.dialog = true
      this.loadFiltro()
    },
    loadFuncaoPessoa (tipo) {
      const codigo = this.codigo
      const pessoa = tipo || this.pessoa.tipo_pessoa
      if (pessoa === 1) {
        if (codigo === '') {
          this.verCpf = true
        } else {
          this.verCpf = false
        }
        this.verCnpj = false
        this.tipo = 'pfisica'
        this.nameLabel = 'Nome *'
      } else if (pessoa === 2) {
        if (codigo === '') {
          this.verCnpj = true
        } else {
          this.verCnpj = false
        }
        this.verCpf = false
        this.tipo = 'pjuridica'
        this.nameLabel = 'Razão social *'
        this.loadInstituicao()
        this.loadAtuacao()
      }
    },
    loadTbelas () {
      this.loadInstrucao()
      this.loadProfissao()
      this.loadRaca()
    },
    loadUser () {
      const tipo = 1
      this.pessoa.tipo_pessoa = 1
      this.loadPessoa()
      this.cad = true
      this.pessoa.usuario = this.user.id
      this.pessoa.uuid = uuid.v1()
      this.codigo = ''
      this.pessoa.email_confirma = null
      this.pessoa.email = null
      this.loadFuncaoPessoa(tipo)
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>
